module.exports = __webpack_public_path__ + "img/home_mentors.4857d67a.jpg";